import React from "react";
import { escapeRegex } from "../../lib/utils";

interface HighlightedTextProps {
  text: string;
  searchTerm: string;
}

const HighlightedText: React.FC<HighlightedTextProps> = ({ text, searchTerm }) => {
  if (!searchTerm.trim()) {
    return <>{text}</>;
  }

  const escapedTerm = escapeRegex(searchTerm);
  const regex = new RegExp(`(${escapedTerm})`, "gi");
  const parts = text.split(regex);

  return (
    <>
      {parts.map((part, index) => {
        if (part.toLowerCase() === searchTerm.toLowerCase()) {
          return (
            <mark
              key={index}
              className="bg-yellow-300 dark:bg-yellow-600 text-warm-text-primary"
            >
              {part}
            </mark>
          );
        }
        return <span key={index}>{part}</span>;
      })}
    </>
  );
};

export default HighlightedText;
